var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "white px-5", attrs: { id: "gvl-header" } }, [
    _c(
      "div",
      { attrs: { id: "header-logos" } },
      [
        _c(
          "v-row",
          { staticClass: "align-center my-0 px-0 px-sm-2 py-5" },
          [
            _c("v-col", { attrs: { cols: "4", md: "5", lg: "6" } }, [
              _c(
                "a",
                {
                  staticClass: "text-decoration-none",
                  attrs: { href: "https://gvl.de/", target: "blank" }
                },
                [
                  _c("img", {
                    staticClass: "logo--new-start mr-2 mr-sm-3 mr-md-6",
                    attrs: { src: require("@/assets/images/logo_detail.png") }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "text-decoration-none",
                  attrs: {
                    href:
                      "https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien/corona-hilfen",
                    target: "blank"
                  }
                },
                [
                  _c("img", {
                    staticClass: "logo--new-start",
                    attrs: {
                      src: require("@/assets/images/logo_new_start.png")
                    }
                  })
                ]
              )
            ]),
            !_vm.isSignMode
              ? _c(
                  "v-col",
                  {
                    staticClass: "nav-menu",
                    attrs: { cols: "8", md: "7", lg: "6" }
                  },
                  _vm._l(_vm.menuItems, function(menu) {
                    return _c(
                      "a",
                      {
                        key: menu.route,
                        class:
                          _vm.$route.name === menu.route && "menu-selected",
                        on: {
                          click: function($event) {
                            return _vm.gotoRoute(menu.route)
                          }
                        }
                      },
                      [_vm._v(_vm._s(menu.label))]
                    )
                  }),
                  0
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }